document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initPlaceholderVideo();
  initForms();
});

/**
 * Toggle the mobile navigation menu from the burger button.
 */
function initMobileNav() {
  var header = document.querySelector('.header');
  var burger = document.querySelector('.header__burger');
  var mobileNav = document.querySelector('.header__nav-mobile');

  if (!header || !burger || !mobileNav) {
    return;
  }

  burger.addEventListener('click', function () {
    var isOpen = header.classList.toggle('header--nav-open');
    burger.setAttribute('aria-expanded', String(isOpen));
    mobileNav.hidden = !isOpen;
  });

  mobileNav.querySelectorAll('.header__link').forEach(function (link) {
    link.addEventListener('click', function () {
      header.classList.remove('header--nav-open');
      mobileNav.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
    });
  });
}

/**
 * The hero video is a placeholder block (no real video asset supplied).
 * Clicking play swaps in a simple "playing" state instead of failing silently.
 */
function initPlaceholderVideo() {
  var playButton = document.querySelector('.hero__play');
  var frame = document.querySelector('.hero__video-frame');

  if (!playButton || !frame) {
    return;
  }

  playButton.addEventListener('click', function () {
    var icon = frame.querySelector('.placeholder__icon');
    if (icon) {
      icon.textContent = '⏸';
    }
    playButton.setAttribute('aria-label', 'Видео недоступно в демо-версии сайта');
    playButton.disabled = true;
  });
}

/**
 * Demo-only form handling: prevents page reload and shows a lightweight
 * confirmation message next to the submitted form.
 */
function initForms() {
  var forms = document.querySelectorAll('.portrait__form, .contact__form');

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      showFormConfirmation(form);
    });
  });
}

function showFormConfirmation(form) {
  var existing = form.querySelector('.form-confirmation');
  if (existing) {
    existing.remove();
  }

  var message = document.createElement('p');
  message.className = 'form-confirmation';
  message.textContent = 'Заявка принята. Мы свяжемся с вами в ближайшее время.';

  form.appendChild(message);
}

